module.exports = __webpack_public_path__ + "95465bf208d41d5bc6b756ccea9c79af.pdf";